export default __webpack_public_path__ + "static/3-b86af55bae76bc1bbcbc6cf2cfc66caa.webp";